<template>
  <div v-if="!loading" class="custom-margin-full-page">
    <global-snack-bar-desktop></global-snack-bar-desktop>
    <v-row>
      <v-col cols="12" class="title-courses">
        <img class="custom-shape-circle-red-course" src="@/assets/shape-02.png" alt="red-circle">
        دوره های شما
      </v-col>
      <v-col cols="12" v-if="!courses.length">
        نام شما در دوره ای ثبت نیست. برای دیدن درس ها ابتدا باید دوره مورد نظر را انتخاب و اشتراک آن را تهیه کنید.
      </v-col>
      <v-col cols="12">
        <v-row>
          <v-col cols="4" v-for="course in courses" :key="course.id">
            <img class="custom-shape-red-course" src="@/assets/red-dots.png" alt="red-dots">
            <v-card elevation="0" class="course-card pa-6"
                    @click="$router.push('/dashboard/sessions/'+course.class_id)">
              <v-card-title class="text-center white-background">
                {{ course.title }}
              </v-card-title>
              <v-card-text class="white-background">
                <v-row>
                  <v-col cols="12">
                    <img class="course-cover" width="100%" height="200px" :src="course.cover_file"
                         :alt="course.title">
                  </v-col>
                  <v-col cols="12" v-if="course.sub_title">
                    {{ course.sub_title }}
                  </v-col>
                  <v-col cols="12" v-if="course.description">
                    {{ course.description }}
                  </v-col>
                  <v-col cols="12" v-if="course.details">
                    {{ course.details }}
                  </v-col>
                  <v-col cols="5">
                    زمان دوره : {{ course.duration }} ماه
                  </v-col>
                  <v-col cols="7">
                    زمان ویدیو های دوره : {{ course.total_time }} دقیقه
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import GlobalSnackBarDesktop from "@/components/Components/Desktop/Notification/GlobalSnackBarDesktop.vue";

export default {
  name: "MyCoursesSessionsDesktop",
  components: {GlobalSnackBarDesktop},
  data() {
    return {
      loading: true,
      courses: [],
    }
  },
  methods: {
    getCourses() {
      window.axios.get('student/courses/index/all').then((res) => {
        this.courses = res.data.data
        this.loading = false
      })
          .catch((err) => {
            this.loading = false
            if (err.response.status === 400) {
              this.openSnackbar(err.response.data.message, '#F1416C')
            }
          })
    }
  },
  mounted() {
    this.getCourses()
  }
}
</script>

<style scoped>
.custom-margin-full-page {
  margin: 0 10vw 0 10vw;
}

.title-courses {
  margin-top: 5vh;
  margin-bottom: 3vh;
  font-size: 1.5vw !important;
}

.course-card {
  cursor: pointer;
  border-radius: 15px;
  background-color: #1ab69d;
}

.white-background {
  background-color: white;
}

.course-cover {
  border-radius: 15px;
}

.buy-btn {
  letter-spacing: normal;
  color: white;
  border-radius: 15px;
  width: 200px;
  padding: 25px !important;
}

.custom-shape-red-course {
  position: absolute;
  top: 20vh;
  margin-right: -2vw;
}

.custom-shape-circle-red-course {
  transform: rotate(15deg);
  position: absolute;
  top: 8vh;
  right: 8vw;
}
</style>